<template>
  <div id="paginaAllestimenti">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Ricevute</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropStagioni' ref='dropStagioni' :query='queryStagioni' :dataSource='stagioniData'
                  :index='stagioniIndex' :fields='stagioniFields' :change='onStagioneChange'
                  v-model="stagioneCorrente"
                  placeholder='Seleziona un Anno'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropSpettacoli" ref="dropSpettacoli" :query="querySpettacoli"
                  :dataSource="elencoSpettacoliList" :index="spettacoliIndex" :fields="elencoSpettacoliFields"
                  :enabled="dropSpettacoliEnabled" :change="onSpettacoloChange"
                  v-model="spettacoloCorrente" :allowFiltering="true"
                  :filtering="spettacoloFiltering"
                  placeholder="Seleziona uno Spettacolo"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">

                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="scrittureFullData" :allowSorting="true"
                    :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                    :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                    >
                    <e-columns>
                      <e-column field="id" headerText="Id" width="10" :isPrimaryKey="true" :visible="false"></e-column>
                      <e-column
                        field="soggetto" headerText="Cognome" width="50"
                        foreignKeyField="id" foreignKeyValue="cognome" :dataSource="this.elencoSoggFiltratiList"
                      ></e-column>
                      <e-column
                        field="soggetto" headerText="Nome" width="40"
                        foreignKeyField="id" foreignKeyValue="nome" :dataSource="this.elencoSoggFiltratiList"
                      ></e-column>
                      <e-column field="ruoloGenerale" headerText="Ruolo" width="50"></e-column>
                      <e-column field="tipoRicevuta" headerText="Tipologia" width="80"></e-column>
                      <e-column field="statoRicevute" headerText="Stato" width="40"></e-column>
                      <e-column field="notaRicevuta" headerText="Nota" width="80"></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

    <!-- dialogA1: dialogDettaglioRicevute ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA1" ref="dialogA1" :header="dialogA1.header" :buttons="dialogA1.buttons"
      :visible="dialogA1.visible" :showCloseIcon="dialogA1.showCloseIcon" :close="dialogA1Close" :open="dialogA1Open"
      :zIndex="dialogA1.zIndex" :animationSettings="dialogA1.animationSettings">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Ricevute">

          <b-row class="match-height">

            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ricevuta</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia Ricevuta</label>
                      <ejs-dropdownlist id="tipologia" ref="tipologia" v-model="ricevutaActiveData.tipologia"
                        :dataSource="tipoRicevutaList" :fields="tipoRicevutaFields" placeholder="Tipologia Ricevuta"
                        />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="compensoTotale" class="h5">Compenso Totale</label>
                      <ejs-numerictextbox
                        id="compensoTotale"
                        v-model="scritturaActiveData.compenso_totale_effettivo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso Totale"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="rivalsa" class="h5">Rivalsa ex IMPALS</label>
                      <ejs-numerictextbox
                        id="rivalsa"
                        v-model="scritturaActiveData.rivalsa_effettiva"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Rivalsa"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" >
                      <label for="banca1IBAN" class="h5">IBAN Principale</label>
                      <ejs-textbox
                        id="banca1IBAN"
                        v-model="soggettoActiveData.banca1IBAN"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="IBAN"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="nota" class="h5">Annotazione</label>
                      <ejs-textbox
                        id="nota"
                        v-model="ricevutaActiveData.nota"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="text-right mt-1" v-show="showDownload">
                      <ejs-button id="downloadRicevutaButton" cssClass="e-flat"
                        @click.native="downloadRicevuta()">Scarica la ricevuta</ejs-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, LinkPlugin, AlertPlugin, ProgressPlugin,
  ToastPlugin, SpinnerPlugin,
} from 'bootstrap-vue'
// import Vuexy
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import {
  DatePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import { Query } from '@syncfusion/ej2-data'
import {
  TextBoxPlugin, NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Aggregate,Group ,ForeignKey, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";

const axios = require('axios')
// use bootstrap-vue
Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(DatePickerPlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(DropDownListPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ButtonPlugin)
enableRipple(true)
// api
const apiSoggettiUrl = "/demo/api/soggetto";
const apiSpettacoloUrl = '/demo/api/spettacolo'
const apiRicevutaUrl = '/demo/api/ricevuta'
const apiScritturaRicercaUrl = "/demo/api/scrittura/ricerca";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {
  },
  data() {
    return {
      loading: false,
      // per gestione stagioni
      stagioniData: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      queryStagioni: null,
      stagioneCorrente: null,
      // per gestione spettacoli
      elencoSpettacoliList: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,
      dropSpettacoliEnabled: false,
      querySpettacoli: null,
      spettacoloCorrente: null,
      showDownload: false,
      // gestione elementi nascosti
      nonMostrare: false,
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        firstDayOfWeek: 1,
        minMoneyNumber: 0,
      },
      // allestimenti
      scrittureFullData: [], // elenco completo scritture dello spettacolo
      ricevuteFullData: [], // elenco completo ricevute
      ricevutaActiveId: 0, // Id ricevuta scelta attiva (0 se nuovo)
      ricevutaActiveData: {}, // dati completi della scrittura
      scritturaActiveData: {}, // dati della scrittura selezionata
      soggettoActiveData: {}, // dati del soggetto interessato dalla scrittura
      operazione: 'show',
      // elenco soggetti
      elencoSoggFiltratiList: [],

      tipoRicevutaMap: {
        '1': 'Proforma di fattura Ordinaria',
        '2': 'Proforma di fattura Forfettaria',
        '3': 'Ricevuta di RA 20%',
        '4': 'Ricevuta di RA 30%',
        '5': 'Ricevuta di RA A1',
        '6': 'Diritti RA 75%',
        '7': 'Diritti RA 60%',
        '8': 'Ricevuta di collaborazione RA 20%',
        '9': 'Ricevuta di collaborazione RA 30%',
      },
      // elenco tipo ricevute
      tipoRicevutaList: [
        { label: 'Proforma di fattura Ordinaria', id: '1' },
        { label: 'Proforma di fattura Forfettaria', id: '2' },
        { label: 'Ricevuta di RA 20%', id: '3' },
        { label: 'Ricevuta di RA 30%', id: '4' },
        { label: 'Ricevuta di RA A1', id: '5' },
        { label: 'Diritti RA 75%', id: '6' },
        { label: 'Diritti RA 60%', id: '7' },
        { label: 'Ricevuta di collaborazione RA 20%', id: '8' },
        { label: 'Ricevuta di collaborazione RA 30%', id: '9' },
      ],
      tipoRicevutaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei ruoli


      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogA1Ok, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogA1Cancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Genera', tooltipText: 'Genera Ricevuta', prefixIcon: 'e-expand', id: 'edit',
          },
          {
            text: 'Mostra', tooltipText: 'Mostra Ricevuta', prefixIcon: 'e-expand', id: 'show',
          },
          {
            text: 'Download', tooltipText: 'Download Ricevuta', prefixIcon: 'e-expand', id: 'download',
          },
          'Search',
        ],
      }, //



    }
  },
  created() {
    // log
    console.log('Pagina Ricevute Creata')
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem('userData') !== null) {
      console.log('Recupero elenchi dal backend')
      useJwt.get(apiSpettacoloUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN")
          alert("Effettua di nuovo il login")
        } else {
          console.log("Elenco Spettacoli");
          console.log(d.data);
          this.elencoSpettacoliList = d.data;
        }
      });

    // soggetti filtrati (artisti e tecnici)
    useJwt.get(apiSoggettiUrl).then((d) => {
      console.log("Elenco soggetti anagrafica");
      console.log(d.data);
      this.elencoSoggFiltratiList = d.data;
      // filtro in base a isArtista o isTecnico
      const results = this.elencoSoggFiltratiList.filter((obj) => {
        return obj.isArtista === true || obj.isTecnico === true;
      });
      console.log("Elenco Soggetti Filtrati");
      console.log(results);
      this.elencoSoggFiltratiList = results;
    });

    // elenco ricevute
    useJwt.get(apiRicevutaUrl).then((d) => {
      if (d.status != 200) {
        console.log("REDIRIGERE A LOGIN")
        alert("Effettua di nuovo il login")
      } else {
        console.log("Elenco ricevute");
        console.log(d.data);
        this.ricevuteFullData = d.data;
      }
    });

    } else {
      console.log('Non trovo UserData, prova ancora')
    }

  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Group, Aggregate],
  },
  methods: {
    spettacoloFiltering: function (e) {
      var searchData = this.elencoSpettacoliList;
      var query = this.querySpettacoli.clone();
      if (e.text != "") {
        query = query.where("titolo", "contains", e.text, true);
      }
      e.updateData(searchData, query);
    },
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      this.querySpettacoli = new Query().where("stagione", "equal", this.$refs.dropStagioni.ej2Instances.value);
      this.dropSpettacoliEnabled = true;
    },
    onSpettacoloChange: function (e) {
      // abilito gridA
      this.$refs.gridA.$el.classList.remove('disablegrid');
      document.getElementById("GridParent").classList.remove('wrapper');
      // Inserire la chiamata per popolare la gridA e aggiornare il titolo di "Elenco Allestimenti" e sottotitolo
      this.loading = true
      console.log("Recupero elenco allestimenti dal backend");
      const datiDaInviare = {
        spettacolo: this.spettacoloCorrente,
      };
      if (datiDaInviare.spettacolo === null) {
        console.log("Spettacolo non ancora selezionato");
      } else {

        useJwt.post(apiScritturaRicercaUrl, datiDaInviare).then((d) => {
          // prendo solo le scritture con stato confermato
          this.scrittureFullData = d.data.filter((obj) => {
            return obj.stato === "confermato";
          });

          console.log("Elenco scritture collegate");
          console.log(this.scrittureFullData);
          this.loading = false;
          this.scrittureFullData.forEach((obj) => {
            if (obj.ricevuta) {
              console.log(obj.ricevuta)
              obj.statoRicevute = "OK"
              const i = this.ricevuteFullData.findIndex((x) => x.id === obj.ricevuta)
              if (i >= 0) {
                const t = this.ricevuteFullData[i] // ho la ricevuta di cui prendere la tipologia
                console.log("TIPO RICEVUTA")
                console.log(t.tipologia)
                console.log(this.tipoRicevutaMap[t.tipologia])
                obj.tipoRicevuta = this.tipoRicevutaMap[t.tipologia]
                obj.notaRicevuta = t.nota
              }
            } else {
              obj.statoRicevute = "--"
            }
          })
        });
      }
    },

    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true)
    },
    dialogA1Open(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

      console.log('Apertura dialogA1')

    },
    dialogA1Close() {
      console.log('Chiusura dialogA1')
      this.dialogA1.tabAdialogA1Index = 0
      this.allestimentiActiveData.documenti = []
    },
    dialogA1Ok() {
      console.log('Cliccato bottone OK di dialogA1')
      console.log(this.ricevutaActiveId)
      if (this.operazione === 'edit') {
        this.ricevutaActiveData['id_scrittura'] = this.scritturaActiveData.id
        console.log("RICEVUTA ACTIVE DATA")
        console.log(this.ricevutaActiveData)
        // console.log(this.scritturaActiveData)
        this.ricevutaActiveData['compenso_totale_effettivo'] = this.scritturaActiveData['compenso_totale_effettivo']
        this.ricevutaActiveData['rivalsa_effettiva'] = this.scritturaActiveData['rivalsa_effettiva']

        useJwt.post(apiRicevutaUrl, this.ricevutaActiveData).then((d) => {
          // gestione risposta
          console.log("risposta server");
          console.log(d.data);
          // TODO: aggiornamento tabella?
          this.scrittureFullData.forEach((obj) => {
            // console.log(obj.id)
            // console.log(d.data['id'])
            if (obj.id === this.scritturaActiveData.id) {
              console.log("TROVATA SCRITTURA")
              obj.tipologia = d.data['tipologia']
              obj.tipoRicevuta = this.tipoRicevutaMap[obj.tipologia]
              obj.statoRicevute = "OK"

              obj.nota = d.data['nota']
              obj.notaRicevuta = d.data['nota']
              obj.ricevuta = d.data['id']
            }
          })
          this.scrittureFullData = [ ...this.scrittureFullData ]
        })
      } else {
        console.log("show, quindi no salvataggio")
      }
      this.$refs.dialogA1.hide()
    },
    dialogA1Cancel() {
      console.log('Cliccato bottone Cancel di dialogA1')
      this.$refs.dialogA1.hide()
    },
    // per gridA
    gridAClickHandler(args) {
      try {
        const selectedRow = this.$refs.gridA.getSelectedRecords()
        this.ricevutaActiveId = selectedRow[0].ricevuta
        this.scritturaActiveData = selectedRow[0]
        console.log("SCRITTURA SELEZIONATA")
        console.log(selectedRow[0])
        console.log(this.ricevutaActiveId)
        if (this.ricevutaActiveId) {
          // modifica ricevuta esistente
          console.log("ID ricevuta: ", this.ricevutaActiveId)
          // dobbiamo recuperare la ricevuta con questo ID
          useJwt.get(apiRicevutaUrl + '/' + this.ricevutaActiveId).then((d) => {
            if (d.status != 200) {
              console.log("REDIRIGERE A LOGIN")
              alert("Effettua di nuovo il login")
            } else {
              this.ricevutaActiveData = d.data.data;

              if (args.item.id === 'download') {
                this.downloadRicevuta();
              } else {
                console.log("Ricevuta");
                console.log(this.ricevutaActiveData);
                this.$refs.tipologia.ej2Instances.value = Number(this.ricevutaActiveData.tipologia)
                this.$refs.tipologia.ej2Instances.refresh()
              }
            }
          });
        } else {
          if (args.item.id === 'download') {
            this.makeToast('primary', 'Attenzione', 'Selezionata scrittura senza ricevuta associata')
          } else {
            // ricevuta da generare
            console.log("scrittura senza ricevuta associata")
            this.scritturaActiveData.rivalsa_effettiva = this.scritturaActiveData.rivalsa
            this.scritturaActiveData.compenso_totale_effettivo = this.scritturaActiveData.compenso_totale
          }
        }
        if (args.item.id === 'edit') {
          this.dialogA1.header = 'Genera Ricevuta'
          console.log('Premuto pulsante genera ricevuta da gridA')
          this.operazione = 'edit'
        } else {
          this.operazione = 'show'
          this.showDownload = true
          console.log('Premuto pulsante mostra ricevuta da gridA')
        }

        useJwt.get(apiSoggettiUrl + '/' + this.scritturaActiveData.soggetto).then((d) => {
          if (d.status != 200) {
            console.log("REDIRIGERE A LOGIN")
            alert("Effettua di nuovo il login")
          } else {
            console.log("soggetto");
            console.log(d.data);
            this.soggettoActiveData = d.data
          }
        });
        if (args.item.id !== 'download') {
          this.$refs.dialogA1.show(true)
        }
      } catch (err) {
        console.log('Occorre selezionare una riga della tabella')
        this.makeToast('primary', 'Attenzione', 'Occorre selezionare una riga della tabella')
      }
    },

    // per download 
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance
        .get(url, {
          responseType: "arraybuffer",
          crossdomain: true,
        })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    downloadRicevuta() {
      console.log("Cliccato bottone Download Ricevuta");
      //ZZZZ
      const ricevutaUrl = this.ricevutaActiveData.fileDocumento
      console.log(ricevutaUrl);

      const nomeFile = ricevutaUrl.split("\\")
        .pop()
        .split("/")
        .pop()
        .split("?")[0];
      this.downloadFile(ricevutaUrl, nomeFile);
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    noop() {
      console.log("premuto enter")
    },

  },
  computed: {
    hasChanged() {
      // console.log(this.allestimentiActiveData)
      // console.log(this.allestimentiSavedData)
      return Object.keys(this.allestimentiActiveData).some(field => this.allestimentiActiveData[field] !== this.allestimentiSavedData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
